import React from 'react';
import { createRoot } from 'react-dom/client';
import { MotionConfig } from 'motion/react';
import './index.css';
import App from './App';

// Global error handler to suppress image loading errors (especially YouTube thumbnails)
window.addEventListener('error', (event) => {
  // Suppress 404 errors for YouTube images and other external images
  if (
    event.target &&
    event.target.tagName === 'IMG' &&
    (event.target.src?.includes('youtube.com') ||
     event.target.src?.includes('img.youtube.com') ||
     event.message?.includes('Failed to load resource'))
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

// Suppress console errors for failed image loads
const originalError = console.error;
console.error = (...args) => {
  const message = args.join(' ');
  // Filter out YouTube image 404 errors
  if (
    message.includes('img.youtube.com') ||
    message.includes('maxresdefault.jpg') ||
    (message.includes('Failed to load resource') && message.includes('404'))
  ) {
    return; // Suppress these errors
  }
  originalError.apply(console, args);
};

// Migrate old single-fetch caches to accumulating format (one-time, keyed by version)
const CACHE_VERSION = 'v3-json-api';
if (localStorage.getItem('rss_cache_version') !== CACHE_VERSION) {
  Object.keys(localStorage)
    .filter(k => k.startsWith('rss_'))
    .forEach(k => localStorage.removeItem(k));
  localStorage.setItem('rss_cache_version', CACHE_VERSION);
}

// Prevent browser from restoring scroll position on refresh
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <MotionConfig reducedMotion="never">
      <App />
    </MotionConfig>
  </React.StrictMode>
);